import React, {useCallback} from 'react';
import {Box, Button, Flex, Highlight, Mark, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast} from "@chakra-ui/react";
import useRequest from "../../../hooks/RequestHook";
import ServerService from "../../../services/ServerService";

export default function DeleteAcademicGroupModal({fksGroup, academicGroup, controller, onDelete = (academicGroup) => undefined, ...props}) {
    //initial components
    const toast = useToast()

    //initial requests
    const deleteAcademicGroupRequest = useRequest(ServerService.deleteAcademicGroup, {
        defaultConfig: {
            id: fksGroup['_id'],
            number: academicGroup['number']
        }
    })

    //initial actions
    const onDeleteAcademicGroup = useCallback(() => {
        deleteAcademicGroupRequest.start(undefined, {
            onSuccessCallBack: (response, data) => {
                controller.onClose()
                onDelete(academicGroup)
                toast({
                    title: academicGroup['number'],
                    description: `Академическая группа ${academicGroup['number']} удалена из ФСК группы ${fksGroup['number']}`,
                    position: 'top-right',
                    status: 'success',
                    isClosable: true,
                })
            },
            onErrorCallBack: () => (
                toast({
                    title: academicGroup['number'],
                    description: `Ошибка удаления академической группы ${academicGroup['number']} из ФСК группы ${fksGroup['number']}`,
                    position: 'top-right',
                    status: 'error',
                    isClosable: true,
                })
            )
        })
    }, [])

    //build view
    return (
        <Modal
            closeOnOverlayClick={false}
            returnFocusOnClose={false}
            isOpen={controller.isOpen}
            onClose={controller.onClose}
            {...props}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader userSelect={'none'}>Удаление академической группы</ModalHeader>
                <ModalBody pb={6} userSelect={'none'}>
                    <Highlight
                        query={[academicGroup['number'], fksGroup['number']]}
                        styles={{
                            px: '1',
                            color: 'white',
                            fontWeight: 'medium',
                            bg: 'red.500',
                            rounded: '5',
                        }}>
                        {`Вы действительно хотите удалить академическую группу ${academicGroup['number']} из группы ФСК ${fksGroup['number']} ?`}
                    </Highlight>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme='red'
                        width={'100%'}
                        mr={3}
                        onClick={onDeleteAcademicGroup}
                        isLoading={deleteAcademicGroupRequest.isLoading}>Удалить</Button>
                    <Button
                        width={'100%'}
                        onClick={() => controller.onClose()}
                        isDisabled={deleteAcademicGroupRequest.isLoading}>Отмена</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}